import { BACKEND_PRIVATE } from '@/api/base'

export async function getApplication(id: LX.GigApplication['id']) {
  return BACKEND_PRIVATE.get<LX.GigApplication>('/me/gigs/applications/get', { params: { id } })
}

export async function readApplications(ids: LX.GigApplication['id'][]) {
  return BACKEND_PRIVATE.post(`/me/gigs/applications/mark-read`, null, { params: { ids } })
}
